import { useReducer } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import BannerManager from "Components/AnnouncementBanner/BannerManager";
import { getProfileCompletionBannerMessage } from "Components/ProfileCompletionReminder/ProfileCompletionReminder";
import TrialCountdown from "Components/TrialStatus/TrialCountdown";
import useTrialStatus from "hooks/useTrialStatus";
import { TRIAL_BANNER_ID } from "Utils/trialStatus";

const AnnouncementSlot = ({
  user,
  enabled = true,
  showTrial = true,
  showProfileBanner = false,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const trial = useTrialStatus(user, { enabled });
  // Re-render when the countdown hits zero so the stage moves past the trial.
  const [, rerender] = useReducer((count) => count + 1, 0);

  if (!enabled) return null;

  const handleTrialEnded = () => {
    rerender();
    // The trial has converted to the paid plan; pick up the new entitlements.
    queryClient.invalidateQueries(["user-entitlements"]);
  };

  const trialMessage =
    showTrial && trial.bannerMessage?.countdownTo
      ? {
          ...trial.bannerMessage,
          text: (
            <TrialCountdown
              endsAt={trial.bannerMessage.countdownTo}
              onComplete={handleTrialEnded}
            />
          ),
        }
      : showTrial
        ? trial.bannerMessage
        : null;

  const messages = [
    trialMessage,
    showProfileBanner
      ? getProfileCompletionBannerMessage(user, () => navigate("/profile/edit"))
      : null,
  ];

  const handleDismiss = (message) => {
    if (message.id === TRIAL_BANNER_ID) trial.dismissBanner();
  };

  return <BannerManager messages={messages} onDismiss={handleDismiss} />;
};

export default AnnouncementSlot;
